import { AnimatePresence } from 'framer-motion';
import { useAssociateContext } from '../../contexts/AssociateProvider';
import { Associate } from '../../types/associates';
import AssociateRequestDetailsModal from '../CommonComps/Modals/AssociateRequestDetailsModal';

const AssociateDetailsModalSection = () => {
  // integration of context hooks here
  const { associate, setAssociate, showDetailsModal, setShowDetailsModal } =
    useAssociateContext();

  // rendering associate details modal section component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showDetailsModal && (
          <AssociateRequestDetailsModal
            associate={associate as Associate}
            handleModalClose={() => {
              setShowDetailsModal(false);
              setAssociate(null);
            }}
            isReadOnly
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default AssociateDetailsModalSection;
